import React from 'react';
/* eslint-disable */
export const BeginnerDifficulty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="45"
    width="84"
    viewBox="0 0 84 45"
    data-testid="svg-beginner-difficulty"
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M22.43 36.75v-.52c-.141-8.426 6.672-15.372 15.224-15.52 8.552.148 15.365 7.094 15.224 15.52v.52h13.194v-.52c0-16-12.728-29-28.418-29-15.691 0-28.418 13-28.418 29v.52H22.43z"
      />
      <path
        fill="#F26422"
        d="M22.846 32.61l-13.63-.86a23.59 23.59 0 0 0 0 4.48v.52H22.41v-.52c.004-1.22.15-2.434.436-3.62z"
      />
      <path
        fill="#333"
        d="M37.633 7.75c7.537 0 14.766 2.95 20.095 8.201 5.33 5.251 8.323 12.373 8.323 19.799H53.62c0-8.698-7.157-15.75-15.986-15.75-8.828 0-15.985 7.052-15.985 15.75H9.216c0-15.464 12.723-28 28.417-28zm0-1.75C20.967 6.022 7.462 19.329 7.44 35.75v1.75h15.985v-1.75c0-7.732 6.362-14 14.21-14 7.847 0 14.208 6.268 14.208 14v1.75h15.985v-1.75C67.805 19.329 54.3 6.022 37.633 6z"
      />
      <path
        fill="#333"
        d="M37.633 37.75l.548-3.48L.426 30.19H.162c-.203 0-.213 0 0 .08.086.026.175.043.264.05l.792.16 2.03.4 4.273.87 4.364.87 4.638.93 4.679.93 4.496.9 4.06.82 3.47.69 2.599.52 1.532.31.274.03z"
      />
    </g>
  </svg>
);
